import { render } from "./cbox.vue?vue&type=template&id=cce62a94&scoped=true"
import script from "./cbox.vue?vue&type=script&lang=js"
export * from "./cbox.vue?vue&type=script&lang=js"

import "./cbox.vue?vue&type=style&index=0&id=cce62a94&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cce62a94"]])

export default __exports__